<template>
  <myDialog :isDialog="isShowCz" title="重置账号" :isFooter="true" @handleClose="$emit('dialogClose')">
    <template slot="content">
      <div class="data">
        <img src="@/assets/images/gzq/cz.png" alt="">
        <span>是否重置账号的密码？</span>
      </div>
    </template>
    <template slot="footer">
      <div class="formBtnBox">
        <div class="editBtn"  @click="$emit('dialogClose')">取消</div>
        <div class="saveBtn  ml-4" @click="submit">确定</div>
      </div>
    </template>
  </myDialog>
</template>

<script>
import { resetPwd } from "@/api/sys/user";
export default {
  props:{
    isShowCz:{
      type:Boolean,
      default:false,
    },
    rowData:{
      type:Object,
      default:()=>{}
    }
  },
  data() {
    return {

    }
  },
  created(){
    if(this.rowData){
      // this.getDeatil()
    }
  },
  mounted() {

  },
  methods: {
    submit(){
      resetPwd({id:this.rowData.id}).then(res=>{
        if(res && res.code == 200){
          this.$emit('dialogClose')
          this.$message.success('操作成功！')
        }
      })
    },
    successAddChange(e) {
      this.$emit('dialogClose')
      this.$message.success('操作成功！')
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body{
  padding-top: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.data{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  >img{
    width: 200px;
    height: 200px;
  }
  >span{
    text-align: center;
    color: #1c1c1c;
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: 400;
    font-size: 18px;
    padding-top: 4px;
  }
}
/* 修改垂直滚动条 */
/deep/::-webkit-scrollbar {
  width: 13px; /* 修改宽度 */
}
</style>
